import React from 'react';
import ReactDOM from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';

import { Amplify, Analytics } from 'aws-amplify';
import config from './aws-exports';
import App from './App';
import { Toaster } from '@/components/ui/sonner';
import './index.css';
import { trackAnalytics } from './analytics/configure';
import posthog from './analytics/posthog';

Amplify.configure(config);
trackAnalytics(Analytics);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
      <Toaster position="bottom-center" />
    </PostHogProvider>
  </React.StrictMode>
);
